import React from "react";
import { usePermissions } from "../../contexts/PermissionContext";
import TabGroup from "../../componentLibrary/TabGroup";
import InProgressCarousel from "./components/InProgressCarousel";
import TopicCardGrid from "./components/TopicCardGrid";
import ToolboxList from "./components/ToolboxList";

export default function ExplorePage() {
  const { userProfile } = usePermissions();
  const greetingName = userProfile?.displayName || userProfile?.username || "";
  const greeting = greetingName ? `Welcome, ${greetingName}` : "Welcome";

  return (
    <div className="container mx-auto px-4 flex flex-col flex-grow pb-12">
      <div className="mt-3 pb-3 mb-3 border-b border-gray-200">
        <h2>{greeting}</h2>
      </div>

      {/* ── Desktop layout (md+): two columns ── */}
      <div className="hidden md:flex gap-6 flex-grow">
        <div className="w-[380px] flex-shrink-0 flex flex-col gap-6 border-r border-gray-200 pr-6">
          <section>
            <h3 className="mb-2">In Progress</h3>
            <InProgressCarousel />
          </section>
          <section>
            <h3 className="mb-2">My Toolboxes</h3>
            <ToolboxList />
          </section>
        </div>

        <div className="flex-1 min-w-0 pl-0">
          <h3 className="mb-2">Topics</h3>
          <TopicCardGrid />
        </div>
      </div>

      {/* ── Mobile layout (<md): stacked with tabs ── */}
      <div className="md:hidden flex flex-col flex-grow max-w-sm mx-auto w-full">
        <InProgressCarousel />
        <TabGroup
          tabs={[
            {
              label: "Topics",
              content: (
                <div className="pt-3">
                  <TopicCardGrid />
                </div>
              ),
            },
            {
              label: "Toolboxes",
              content: (
                <div className="pt-3">
                  <ToolboxList />
                </div>
              ),
            },
          ]}
        />
      </div>
    </div>
  );
}
